/**
 * Mass Item Upload Actions
 *
 * @author agal0301
 * */

export const RESET_MASS_ITEM_UPLOAD_DATA = 'RESET_MASS_ITEM_UPLOAD_DATA';
export const GET_ITEM_ASSIGNMENT_FILE = 'GET_ITEM_ASSIGNMENT_FILE';
export const VALIDATE_MASS_ITEM_ASSIGNMENT_DATA = 'VALIDATE_MASS_ITEM_ASSIGNMENT_DATA';
export const UPLOAD_MASS_ITEM_DATA = 'UPLOAD_MASS_ITEM_DATA';
export const UPDATE_ITEM_GROUP_MASS_ITEM_ASSOCIATION_DATA = 'UPDATE_ITEM_GROUP_MASS_ITEM_ASSOCIATION_DATA';
export const OPEN_LOADER_FOR_MASS_ITEM_UPLOAD_OPERATION = 'OPEN_LOADER_FOR_MASS_ITEM_UPLOAD_OPERATION';
export const RECEIVE_SUCCESS_IN_MASS_ITEM_UPLOAD_OPERATION = 'RECEIVE_SUCCESS_IN_MASS_ITEM_UPLOAD_OPERATION';

export const resetMassItemUploadData = () => ({
  type: RESET_MASS_ITEM_UPLOAD_DATA,
});

export const getItemAssignmentFile = (data) => ({
  type: GET_ITEM_ASSIGNMENT_FILE,
  data,
});

export const validateMassItemAssignmentData = (data) => ({
  type: VALIDATE_MASS_ITEM_ASSIGNMENT_DATA,
  data,
});

export const uploadMassItemAssignmentData = (data) => ({
  type: UPLOAD_MASS_ITEM_DATA,
  data,
});

export const updateMassItemAssociationData = (data) => ({
  type: UPDATE_ITEM_GROUP_MASS_ITEM_ASSOCIATION_DATA,
  data,
});

export const openLoaderMassItemUploadOperation = (data) => ({
  type: OPEN_LOADER_FOR_MASS_ITEM_UPLOAD_OPERATION,
  data,
});

export const receiveSuccessResponseInMassItemUploadOperation = (data) => ({
  type: RECEIVE_SUCCESS_IN_MASS_ITEM_UPLOAD_OPERATION,
  data,
});
